/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { createRef, useEffect, useState, useMemo } from 'react';
import './pop-over.styles.scss';
import { POP_OVER_ITEM_LIST } from './data/pop-over.data';
import AppService from '../../services/app-service';
import { createStructuredSelector } from 'reselect';
import { getSearchDataState } from '../../../redux/data-saver/data-saver.selectors';
import { connect } from 'react-redux';
import Loader from '../../../assets/loaders/spinner-blue.gif';
import { UP_ACCESS } from '../../utils/permissions';

const PopOver = (props) => {
    const {
        offSetOn = true,
        rowData,
        showToolTip = false,
        dataList = [],
        elementType,
        gridType = '',
        gridDataType = null,
        userData = null,
        listType,
        showLink = false,
        loader = false,
        click,
        viewNotificationLink,
        className,
        gridLen,
        divRef,
        scrollObject,
        hidePreview = false,
    } = props;

    const popOverRef = createRef();

    const basePopOverListArray = useMemo(() => {
        let list = AppService.filterDetailViewWithPermissions(POP_OVER_ITEM_LIST[listType], elementType) || [];

        if (
            rowData?.fileType === 'folder' &&
            rowData?.type?.toLowerCase() === 'covariation network' &&
            UP_ACCESS(['FILE_DOWNLOAD', 'FILE_DOWNLOADS'])
        ) {
            list.push({ img: 'download', name: 'Create Local KME Table' });
        } else if (
            gridDataType?.toLowerCase() === 'covariation networks' &&
            UP_ACCESS(['FILE_DOWNLOAD', 'FILE_DOWNLOADS'])
        ) {
            list.push({ img: 'download', name: 'Download KME Table' });
        }

        return AppService.removeDuplicateObjectFromArray(list, 'name');
    }, [listType, elementType, rowData, gridDataType]);

    const setKeyValueBasedOnPermissions = () => {
        const availableListItems = [...(POP_OVER_ITEM_LIST[listType] || [])];
        availableListItems.forEach(item => {
            if (!basePopOverListArray.some(obj => obj.name === item.name)) {
                item['disabled'] = 'grey';
            }
        });
        return availableListItems;
    };

    const rawPopOverListData = useMemo(() => {
        let list = dataList?.length
            ? dataList
            : elementType || basePopOverListArray.length
                ? basePopOverListArray
                : setKeyValueBasedOnPermissions();

        if (userData) {
            const name =
                userData?.user?.name ||
                `${userData?.user?.first_name || ''}${userData?.user?.last_name || ''}` ||
                userData?.user?.username ||
                '';

            const userDisplay = {
                img: 'username',
                name: name.split(/(?=[A-Z])/).join(' ')
            };
            list = [userDisplay, ...list];
        }

        return list;
    }, [dataList, elementType, basePopOverListArray, listType, userData]);

    const [listData, setListData] = useState([]);

    useEffect(() => {
        let list = [...rawPopOverListData];

        if (dataList.length) {
            list.push({ img: 'clear', name: 'clear all' });
            list = AppService.removeDuplicateObjectFromArray(list, 'name');
            const clearAll = list.find(item => item.name === 'clear all');
            list = list.filter(item => item.name !== 'clear all');
            list.push(clearAll);
        }

        if (rowData?.checked) {
            list = list.filter(item => item.name?.toLowerCase() !== 'download');
        }

        if (listType === 'sampleAttributes') {
            setListData([list[0]]);
        } else {
            if (
                rowData?.fileType &&
                !['pdf', 'xls', 'xlsx', 'csv', 'txt', 'r-code'].includes(rowData?.fileType)
            ) {
                list = list.filter(item => item.name?.toLowerCase() !== 'preview');
            }
            if (hidePreview) {
                list = list.filter(item => item.name?.toLowerCase() !== 'preview');
            }
            setListData(list);
        }
    }, [listType, rowData, dataList, rawPopOverListData, hidePreview]);

    const offSetCal = () => {
        let style = {};
        const offsetList = ['geneSet', 'sampleAttributes', 'fileTypeResults'];
        if (!offsetList.includes(listType)) {
            if (offSetOn) {
                style.top = `${(divRef?.current?.offsetTop - scrollObject?.top) + 25}px`;
            } else {
                const rowElem = document.getSelection();
                style.top = `${(rowElem?.focusNode?.offsetTop - scrollObject?.top)}px`;
            }
        }
        return style;
    };

    const fileSizeChecker = (item) => {
        const sizeText = rowData?.sizeDisplayName;
        if (item.name?.toLowerCase() === 'preview' && sizeText) {
            const [val, unit] = sizeText.split(' ');
            if (['MB', 'GB', 'TB', 'PB'].includes(unit) && parseFloat(val) > 1) {
                return ' grey';
            }
        }
        return '';
    };

    const imageType = (image = '') => {
        return image.toLowerCase().includes('.zip') ? 'zip' : image;
    };

    const popOverListItem = ({ item, index }) => (
        <div
            key={index}
            title={showToolTip ? item.name : ''}
            className={`pop-over-container-list-item${item.img === 'username' ? ' user-name' : ''}${item.disabled ? ` ${item.disabled}` : ''}`}
            onClick={() => listType !== 'recentFiles' && click(item)}
        >
            {item.img !== 'username' && (
                <div className={`pop-over-container-list-item-img ${imageType(item.img)}`} />
            )}
            <div className="pop-over-container-list-item-label" title={item.name}>
                {item.img === 'username' ? (
                    <div className='user-info'>
                        <div className='user-info-name'>{item.name}</div>
                        {userData?.user?.email && (
                            <div className='user-info-email'>{userData.user.email.toLowerCase()}</div>
                        )}
                    </div>
                ) : item.name}
            </div>
        </div>
    );

    return (
        <div
            className={
                `pop-over-container ${className || ''} ${gridType || ''} ${gridDataType || ''}` +
                ((gridType !== 'sampleAttributes' && gridLen > 8) ? ' flow' : '')
            }
            ref={popOverRef}
            style={{ ...offSetCal() }}
        >
            <div className="pop-over-container-list">
                <div className='notification-body-wrapper'>
                    {loader ? (
                        <div className='loader-wrapper'>
                            <img src={Loader} alt="Loading..." />
                        </div>
                    ) : (
                        listData.map((item, index) => popOverListItem({ item, index }))
                    )}
                </div>
                {showLink && (
                    <div className='view-all-notification-link' onClick={viewNotificationLink}>
                        View All Notifications
                    </div>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    advancedSearchData: getSearchDataState
});

export default connect(mapStateToProps)(React.memo(PopOver));
